import { accelFactor, startEpoch, fmtEpochHM, fmtGain } from "./clock";

const TAG = "gaimtime-clock";
const STORAGE_KEY = "gt_live_clock";
let timer = null;

function computeGaim(settings, tz) {
  const factor = accelFactor(settings.target_gain);
  const startEp = startEpoch(settings.start_time, tz);
  const now = Date.now();
  const elapsed = Math.max(0, now - startEp);
  // Before the programmed start: mirror real time (gain 0). After: accelerate.
  const gaimEp = now < startEp ? now : startEp + elapsed * factor;
  const gaimHM = fmtEpochHM(gaimEp, tz);
  const g = fmtGain(elapsed * (factor - 1));
  const gainStr = `${g.h}h${String(g.m).padStart(2, "0")}`;
  return { gaimHM, gainStr };
}

async function showClockNotif(reg, settings, tz, labels) {
  const { gaimHM, gainStr } = computeGaim(settings, tz);
  await reg.showNotification(`\u23F3 GaimTime \u00B7 ${gaimHM}`, {
    tag: TAG,
    body: `${labels.gaim}: ${gaimHM}  \u00B7  ${labels.gain}: +${gainStr}`,
    icon: "/icon-192.png",
    badge: "/icon-192.png",
    silent: true,
    renotify: false,
    requireInteraction: true,
    data: { url: "/dashboard" },
  });
}

export function isLiveClockOn() {
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export async function startLiveClock(settings, tz, labels) {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) {
    return { ok: false, reason: "unsupported" };
  }
  let perm = Notification.permission;
  if (perm === "default") perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: "denied" };
  const reg = await navigator.serviceWorker.ready;
  localStorage.setItem(STORAGE_KEY, "1");
  await showClockNotif(reg, settings, tz, labels);
  if (timer) clearInterval(timer);
  timer = setInterval(() => showClockNotif(reg, settings, tz, labels).catch(() => {}), 60000);
  return { ok: true };
}

export async function stopLiveClock() {
  localStorage.removeItem(STORAGE_KEY);
  if (timer) { clearInterval(timer); timer = null; }
  try {
    const reg = await navigator.serviceWorker.ready;
    const notifs = await reg.getNotifications({ tag: TAG });
    notifs.forEach((n) => n.close());
  } catch { /* ignore */ }
}
